import { http } from '../../../../api/axios';
import { libxConfig } from '../../../../config';
import { GenresListOut } from '../../../../store/apiLibx';

export const fetchLocalContentGenres = () => {
    return http.get<GenresListOut>(libxConfig().endpointGenres).then(res => res.data);
};
